import { OverrideActionCellRenderer } from '@components/DriverTracking/Dwell/components/OverrideActionCell'
import { TemporaryOverrideForm } from '@components/DriverTracking/Dwell/components/TemporaryOverrideForm'
import { Texto } from '@gravitate-js/excalibrr'
import type { IDetailCellRendererParams } from 'ag-grid-community'
import { Form } from 'antd'
import React, { useState } from 'react'

type DwellOverrideCellProps = {
  params: IDetailCellRendererParams
  createHandleOverride: (params) => (values) => void
  createHandleDeleteOverride: (params) => () => void
  hasEdits: boolean
}

export function DwellOverrideCell({
  params,
  createHandleOverride,
  createHandleDeleteOverride,
  hasEdits,
}: DwellOverrideCellProps) {
  if (params.node.group) return null

  const [form] = Form.useForm()
  const [popoverOpen, setPopoverOpen] = useState(false)

  const hidePopover = () => {
    setPopoverOpen(false)
    form.resetFields()
  }

  const handleOpenPopoverChange = (newOpen: boolean) => {
    setPopoverOpen(newOpen)
  }

  const handleOverride = createHandleOverride(params)
  const handleDelete = createHandleDeleteOverride(params)

  const site = params.data?.site_number
  const dwellOverride = params.data?.override_expiry

  return (
    <OverrideActionCellRenderer
      overrideForm={
        <TemporaryOverrideForm
          metadataComponent={<PopoverMetadata site={site} />}
          dwellOverride={dwellOverride}
          form={form}
          handleOverride={handleOverride}
          handleDelete={handleDelete}
          closeForm={hidePopover}
          timezone={params.data?.override_expiry_local}
        />
      }
      hadEdits={hasEdits}
      overrideDwell={params.data?.override_dwell}
      open={popoverOpen}
      handleOpenChange={handleOpenPopoverChange}
    />
  )
}

type PopoverMetadataProps = {
  site: string
}
function PopoverMetadata({ site }: PopoverMetadataProps) {
  return (
    <>
      <Texto weight='bold'>Site</Texto>
      <Texto>{site}</Texto>
    </>
  )
}
